import { Box, Container, Typography } from '@mui/material';
import { LetterSpacedHeading } from 'components/common';

const MeetTheTeam = () => {
  return (
    <Box
      sx={{
        // p: '85px 0 242px',
        p: {
          xs: '50px 0 200px',
          md: '85px 0 242px',
        },
        backgroundColor: '#04B078',
        color: '#fff',
        textAlign: 'center',
      }}
    >
      <Container>
        <Box
          p="20px"
          sx={{
            px: {
              xs: 0,
              md: '20px',
            },
          }}
        >
          <LetterSpacedHeading sx={{ pb: '36px' }} component="h2">
            MEET THE TEAM
          </LetterSpacedHeading>
          <Typography
            component="p"
            fontSize={22}
            fontWeight={300}
            lineHeight="32px"
            // marginX={'60px'}
            sx={{
              mx: {
                xs: 0,
                md: '60px',
              },
            }}
          >
            At POD, we are a team driven by passion, commitment and intellectual
            curiosity to provide our users with an investing and fundraising
            experience par excellence.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default MeetTheTeam;
